import SidebarMenu_vue_vue_type_script_setup_true_lang_default from "./SidebarMenu.vue.script.js";
//#region src/v2/components/sidebar/SidebarMenu.vue
var SidebarMenu_default = SidebarMenu_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { SidebarMenu_default as default };

//# sourceMappingURL=SidebarMenu.vue.js.map